import React from 'react';
import { Button } from './ui/Button';
import { Download, Globe } from 'lucide-react';
export function TopBar() {
  return <div className="bg-[#2B0A3D] text-white py-2 px-4 sticky top-0 z-50 shadow-md" data-id="element-207">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-2 text-xs sm:text-sm" data-id="element-208">
        <div className="flex items-center gap-4 text-center sm:text-left opacity-90" data-id="element-209">
          <span className="flex items-center gap-1" data-id="element-210">
            <Download className="w-3 h-3" data-id="element-211" /> Acceso inmediato
          </span>
          <span className="hidden sm:inline" data-id="element-212">•</span>
          <span className="hidden sm:inline" data-id="element-213">PDF descargable</span>
          <span className="hidden sm:inline" data-id="element-214">•</span>
          <span className="flex items-center gap-1" data-id="element-215">
            <Globe className="w-3 h-3" data-id="element-216" /> Funciona vivas donde vivas
          </span>
        </div>
        <Button href="#oferta" variant="primary" size="sm" className="py-1 h-8 text-xs font-bold uppercase tracking-wider hidden sm:inline-flex" data-id="element-217">
          Comprar ahora
        </Button>
      </div>
    </div>;
}